import { useIndexQuery } from 'api';
import type { ResellerWording } from 'types/models';
import { resellerWordingMapping } from 'utils/resellerUtils';
import { _5_MINUTES_IN_MS } from '../constants';
import { useCurrentRole } from './slices';

export const useGetResellerWordingType = (): ResellerWording => {
  const currentRole = useCurrentRole();
  const isCurrentResourceLab = currentRole?.resource_type === 'Lab';

  const { data: establishmentTypeData } = useIndexQuery(
    'labs/lab/reseller_wording_type',
    undefined,
    { enabled: isCurrentResourceLab, staleTime: _5_MINUTES_IN_MS }
  );

  if (currentRole?.resource_type === 'Pharmacy') {
    return resellerWordingMapping(currentRole.resource.kind);
  }

  return establishmentTypeData?.reseller_wording_type || 'pharmacy';
};
